const section = document.querySelector('.scroll-indicator');
const header =  document.querySelector('.header');

if (section) {


    let wrapper = document.createElement('div');
    wrapper.classList.add('scroll-indicator__wrapper')

    let container = document.createElement('div');
    container.classList.add('scroll-indicator__container');

    let bar = document.createElement('span');
    bar.classList.add('scroll-indicator__bar');
    container.appendChild(bar)
    wrapper.appendChild(container)
    section.appendChild(wrapper);

    let wrapper_elem = section.querySelector('.scroll-indicator__wrapper');
    let container_elem = section.querySelector('.scroll-indicator__container');
    let scrollbar_elem = section.querySelector('.scroll-indicator__bar');


    window.addEventListener('scroll', setScrollProgress);
    window.addEventListener('resize', setScrollProgress);



    function setScrollProgress(){
        let rect = section.getBoundingClientRect();
        let elementScroll = rect.top;
        let heightOfSection = section.scrollHeight;
        let headerHeight =  header.offsetHeight;


        elementScroll -= headerHeight;


        if(elementScroll < 0){
            setOpacity(1);

            let scrolledPart = (Math.abs(elementScroll) / (heightOfSection - window.innerHeight + headerHeight)) * 100;
            scrollbar_elem.style.height = scrolledPart + "%";

            if(scrolledPart > 101){
                setOpacity(0);
            }
        }
        else{
            setOpacity(0);
        }
    }


    function setOpacity(opacity){


        wrapper_elem.style.opacity = opacity;
        //scrollbar_elem.style.opacity = opacity;
        //container_elem.style.opacity = opacity;
    }
}

